export default "__VITE_ASSET__CJ2B7Hf___"